import { getAllTimezones } from 'countries-and-timezones';
import useSettingsService from 'components/hooks/useSettingsService';
import { DefinitionLevels } from 'common/services/settings.service';
import keyBy from 'lodash/keyBy';
import { WORK_DAYS, WORK_DAYS_OPTIONS } from 'common/constants/constants';
import useUserProfile from 'views/root/views/home/hooks/useUserProfile';
import { defaultTime, defaultTimeZone } from './steps.consts';
import { convertTo12Hour } from 'common/utils/time-utils';

const useWorkHours = () => {
  const { userProfileDBData } = useUserProfile();
  const timezones = getAllTimezones();
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const { getTeamOrOrgSetting } = useSettingsService();
  const workingDaysOrg = getTeamOrOrgSetting({
    name: 'workingDays',
    definitionLevel: DefinitionLevels.ORGANIZATION
  });

  const workingDaysByDisplayValue = keyBy(WORK_DAYS_OPTIONS, 'displayValue');
  const workingDaysByValue = keyBy(WORK_DAYS_OPTIONS, 'value');

  const workingDaysInitialState =
    workingDaysByValue[userProfileDBData?.workingDays]?.displayValue ||
    workingDaysByValue[workingDaysOrg]?.displayValue ||
    WORK_DAYS[0];

  const timeInitialState = convertTo12Hour(
    userProfileDBData?.time || defaultTime
  );

  const timeZoneInitialState =
    timezones[userProfileDBData?.timeZone]?.name ||
    timezones[userTimeZone]?.name ||
    timezones[defaultTimeZone]?.name;

  return {
    timeInitialState,
    timeZoneInitialState,
    workingDaysInitialState,
    workingDaysByDisplayValue
  };
};

export default useWorkHours;
